import { Link } from "react-router-dom";

const ValouseExperience = () => {
  return (
    <div className="min-h-screen bg-[#3F2A24] text-[#F3E5CF]">
      <div className="max-w-3xl mx-auto px-6 py-16 space-y-10">
        {/* Back to Valouse */}
        <div className="mb-6">
          <Link
            to="/valouse"
            className="inline-flex items-center gap-2 text-sm text-[#E8D2B5] hover:text-[#F3E5CF] transition-colors"
          >
            <span>← Retour à COCON Valouse</span>
          </Link>
        </div>

        <header className="text-center space-y-3">
          <p className="text-xs tracking-[0.35em] uppercase text-[#E8D2B5]">✧ Ce qui se vit à l’intérieur du COCON</p>
          <h1 className="font-serif text-3xl md:text-4xl">Découvrir l’expérience COCON</h1>
        </header>

        <section className="space-y-8 text-sm leading-relaxed">
          {/* Nourriture nourrissante et gourmande */}
          <article className="px-6 py-8 rounded-3xl bg-[#F3E5CF] text-center text-[#3F2A24] space-y-3 border border-[#E8D2B5]/40">
            <p className="text-xs tracking-[0.35em] uppercase text-[#3F2A24]">
              NOURRITURE NOURRISSANTE ET GOURMANDE
            </p>
            <p>
              Cuisine végétarienne, bio, locale.
              <br />
              Pas des « graines fades ».
              <br />
              Mais des repas sacrés, vivants, et délicieux.
            </p>
            <p>
              Chaque bouchée est une célébration.
              <br />
              Chaque repas… un ancrage dans le corps.
            </p>
          </article>

          {/* Folie sacrée */}
          <article className="px-6 py-8 rounded-3xl bg-[#6B4A3B] text-center text-[#F3E5CF] space-y-3 border border-[#E8D2B5]/40">
            <p className="text-xs tracking-[0.35em] uppercase text-[#F3E5CF]">
              FOLIE SACRÉE
            </p>
            <p>
              On rit.
              <br />
              On pleure.
              <br />
              On crie.
            </p>
            <p>
              On s’effondre.
              <br />
              On renaît.
            </p>
            <p>
              Pas de spiritualité perchée.
              <br />
              Pas de dogmes.
              <br />
              Juste du vrai.
              <br />
              Du vivant.
              <br />
              De l’humain.
            </p>
          </article>

          {/* Le oui inconditionnel */}
          <article className="px-6 py-8 rounded-3xl bg-[#C5A059]/90 text-center text-[#3F2A24] space-y-3 border border-[#F3E5CF]/40">
            <p className="text-xs tracking-[0.35em] uppercase text-[#3F2A24]">
              LE OUI INCONDITIONNEL
            </p>
            <p>
              Tu peux venir :
              <br />
              En miettes.
              <br />
              Fatigué·e.
              <br />
              En fuite douce.
            </p>
            <p>
              Tu es accueilli·e.
            </p>
            <p>
              Il n’y a rien à prouver ici.
              <br />
              Juste un espace pour être.
            </p>
          </article>

          {/* Ce que tu vis vraiment */}
          <article className="px-6 py-8 card-sacred text-center text-[#3F2A24] space-y-4">
            <p className="text-xs tracking-[0.35em] uppercase text-[#3F2A24]">
              CE QUE TU VIS VRAIMENT
            </p>
            <p className="text-xs tracking-[0.35em] uppercase text-[#3F2A24]">
              C’EST UNE TRANSFORMATION INCARNÉE
            </p>
            <p className="space-y-1 text-[#F3E5CF]">
              ✔️ Tu te réveilles sans boule au ventre
              <br />
              ✔️ Tu pleures, et c’est libérateur
              <br />
              ✔️ Tu es enfin vu·e et soutenu·e
              <br />
              ✔️ Tu retrouves ta paix et ta force intérieure
              <br />
              ✔️ Tu sens ton corps, ton ancrage
              <br />
              ✔️ Tu ne te bats plus contre toi
              <br />
              ✔️ Tu ressens une joie sincère et profonde
              <br />
              ✔️ Tu repars entouré·e
            </p>
            {/* Citation retirée sur demande */}
            <div className="mt-6">
              <Link
                to="/valouse/preinscription"
                className="inline-flex items-center justify-center px-8 py-3 rounded-full bg-[#F3E5CF] text-[#3F2A24] text-xs md:text-sm tracking-[0.3em] uppercase font-medium shadow-sm hover:bg-[#E8D2B5] transition-colors duration-300"
              >
                Je veux vivre ça moi aussi
              </Link>
            </div>
          </article>
        </section>
      </div>
    </div>
  );
};

export default ValouseExperience;
